import React from "react";
import IComponentForm from "./interface";
import Container from "./styles";

const Form: React.FC<IComponentForm> = ({
	styleInline,
	...rest
}) => <Container {...rest} styleInline={styleInline}/>;

export default Form;
